import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { apiClient } from '@/api/client';

let lastRecordedPath = null;
let lastRecordTime = 0;

export function SiteVisitTracker() {
  const location = useLocation();

  useEffect(() => {
    const now = Date.now();
    // Prevent double calls in React StrictMode (debounce within 1 second)
    if (lastRecordedPath === location.pathname && (now - lastRecordTime) < 1000) {
      return;
    }

    lastRecordedPath = location.pathname;
    lastRecordTime = now;

    const recordVisit = async () => {
      try {
        await apiClient.post('/record-visit', {
          pageVisited: location.pathname,
          referrer: document.referrer
        });
      } catch (error) {
        console.error("Failed to record site visit:", error);
      }
    };

    recordVisit();
  }, [location.pathname]);

  return null;
}
